import React, { useRef, useState } from "react";

export default function ChartFlashGestureWeb() {
  const svgRef = useRef(null);
  const [points, setPoints] = useState([]);
  const [result, setResult] = useState(null);
  const [xp, setXp] = useState(210);
  const [tokens, setTokens] = useState(325);

  const W = 520, H = 240, P = 16;
  const supportY = 0.62, currentY = 0.35;
  const correct = "pullback";

  const onPointerDown = (e) => {
    const { x, y } = local(e);
    setPoints([{ x, y }]);
    setResult(null);
  };
  const onPointerMove = (e) => {
    if (e.buttons !== 1) return;
    const { x, y } = local(e);
    setPoints((pts) => [...pts, { x, y }]);
  };
  const onPointerUp = () => {
    const normPts = points.map(({ x, y }) => ({
      x: (x - P) / (W - 2*P),
      y: (y - P) / (H - 2*P),
    }));
    const idea = classify(normPts, supportY, currentY);
    const ok = idea === correct;
    setResult(ok ? "correct" : "wrong");
    if (ok) { setXp(v => v + 20); setTokens(v => v + 15); }
  };

  const pathD = points.length
    ? `M ${points[0].x},${points[0].y} ` + points.slice(1).map(p => `L ${p.x},${p.y}`).join(" ")
    : null;

  return (
    <div style={{ background:'#0B0D11', minHeight:'100vh', padding:16, color:'#DDE2EA' }}>
      <div style={{ display:'flex', justifyContent:'space-between', marginBottom:8 }}>
        <strong>🐂 FinTorro</strong>
        <div style={{ display:'flex', gap:8 }}>
          <Pill>🪙 {tokens}</Pill>
          <Pill>✨ {xp}</Pill>
        </div>
      </div>

      <div style={{
        maxWidth: 920, margin:'20px auto', background:'#0F141B', border:'1px solid #1E2630',
        borderRadius:16, padding:16, textAlign:'center'
      }}>
        <h2 style={{ color:'#FF7C24', margin:'6px 0 12px' }}>Chart Flash Reveal</h2>

        <div style={{
          alignSelf:'center', margin:'0 auto', width: W, height: H,
          borderRadius:14, border:'1px solid #1C2128', background:'#0E0F13'
        }}>
          <svg
            ref={svgRef}
            width={W}
            height={H}
            style={{ display:'block', borderRadius:14 }}
            onPointerDown={onPointerDown}
            onPointerMove={onPointerMove}
            onPointerUp={onPointerUp}
          >
            {/* support */}
            <line x1={P} x2={W-P} y1={P+(H-2*P)*supportY} y2={P+(H-2*P)*supportY} stroke="#2A8FBD" strokeWidth="2" />
            {/* current price */}
            <line x1={P} x2={W-P} y1={P+(H-2*P)*currentY} y2={P+(H-2*P)*currentY} stroke="#C97BFF" strokeWidth="1" strokeDasharray="4 4" />

            {/* learner stroke */}
            {pathD && (
              <path d={pathD} fill="none" stroke={result==='wrong' ? '#FF4C4C' : '#FFB800'} strokeWidth="3" strokeLinecap="round" />
            )}

            {/* truth reveal (pullback then up) */}
            {result && (
              <path
                d={`M ${W*0.65},${P+(H-2*P)*currentY} L ${W*0.72},${P+(H-2*P)*supportY} L ${W*0.86},${P+(H-2*P)*(currentY-0.07)}`}
                fill="none" stroke="#2ECC71" strokeWidth="3" strokeLinecap="round"
                style={{ opacity: result==='correct' ? 1 : 0.8 }}
              />
            )}
          </svg>
        </div>

        {result && (
          <div style={{ marginTop:12, fontWeight:800, color: result==='correct' ? '#2ECC71' : '#FF4C4C' }}>
            {result==='correct'
              ? '🎉 Correct! Pullback then resume up. +20 XP +15 Tokens'
              : '❌ Not quite. Look for a small dip to support, then bounce.'}
          </div>
        )}
      </div>
    </div>
  );

  function local(e) {
    const r = svgRef.current.getBoundingClientRect();
    return { x: e.clientX - r.left, y: e.clientY - r.top };
  }
}

function classify(pts, supportY, currentY) {
  if (!pts?.length) return 'continuation';
  const first = pts[0], last = pts[pts.length-1];
  const minY = Math.min(...pts.map(p => p.y));
  const maxY = Math.max(...pts.map(p => p.y));
  const net = last.y - first.y; // +down, -up

  const touchedSupport = maxY >= supportY - 0.02;
  const bounced = last.y < currentY - 0.02;

  if (touchedSupport && bounced) return 'pullback';
  if (net > 0.05) return 'reversal';
  return 'continuation';
}

function Pill({ children }) {
  return <div style={{ background:'#12151B', border:'1px solid #1E232B', padding:'6px 10px', borderRadius:999, fontSize:13 }}>{children}</div>;
}
